import React from "react";
import {  ImageSlider,AppointmentSection, Service,PatientFeedback, HomeEgypt } from "../../Components";

const Home = (props) => {
    return (
        <div>
            <ImageSlider {...props}/>
            <AppointmentSection {...props} />
            <Service {...props} />
            <PatientFeedback {...props} />
            <HomeEgypt {...props} />
        </div>
    )
}

export default Home